/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { CHANGE_USERNAME, ON_CALL_UPLOAD,SET_ITEMS_ERROR, FAILED_INV_VAL, RESET_FETCH_FAILED, ON_NOTIFY, LOADER_STATUS, TOTAL_RECORD, GET_ITEM, TOTAL_ITEM_RECORDS, TXN_RECORD, SET_PAGE_PAGE } from './constants';

// The initial state of the App
export const initialState = {
  username: '',
  uploadData: '',
  failedData: '',
  status: false,
  msg: '',
  loaderStatus: false,
  totalRecords: '',
  itemData: '',
  totalItemRecord: '',
  propsTxnId: '',
  failPage: 1,
  records: '',
  itemErrorData:''
};

/* eslint-disable default-case, no-param-reassign */
const failedReducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHANGE_USERNAME:
        return {
          ...state,
          username:action.username.replace(/@/gi, '')
        }
      case ON_CALL_UPLOAD:
        return {
          ...state,
          uploadData:action.uploadData
        }
      case FAILED_INV_VAL:
        return {
          ...state,
          failedData:action.failedData
        }
      case RESET_FETCH_FAILED:
        return {
          ...state,
          failedData:action.failedData
        }
      case ON_NOTIFY:
        return {
          ...state,
          status:action.status,
          msg:action.msg
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case TOTAL_RECORD:
        return {
          ...state,
          totalRecords:action.totalRecords,
          records:action.records
        }
      case GET_ITEM:
        return {
          ...state,
          itemData:action.itemData
        }
      case TOTAL_ITEM_RECORDS:
        return {
          ...state,
          totalItemRecord:action.totalItemRecord
        }
      case TXN_RECORD: 
        return {
          ...state,
          propsTxnId:action.propsTxnId
        }
      case SET_PAGE_PAGE:
        return {
          ...state,
          failPage:action.failPage
        }
      case SET_ITEMS_ERROR:
        return {
          ...state,
          itemErrorData:action.itemData
        }
      default:
        return state;
    }
  };

export default failedReducer;
